import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiInstagram} = FiIcons;

const Footer = () => (
  <footer className="bg-stone-800 text-white py-12 px-4 sm:px-6 lg:px-8">
    <div className="max-w-7xl mx-auto">
      <div className="grid md:grid-cols-4 gap-8">
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
        >
          <h3 className="text-2xl font-serif mb-4" style={{fontFamily: 'Libre Baskerville,serif'}}>
            YIN UND KLANG
          </h3>
          <p className="text-stone-300 leading-relaxed" style={{fontFamily: 'Lato,sans-serif'}}>
            Hier findest du Raum,um zur Ruhe zu kommen und neue Kraft zu schöpfen. Entdecke die Kraft von Yin Yoga und Klangschalen in unserem exklusiven Format in Kassel.
          </p>
        </motion.div>

        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.2}}
          viewport={{once: true}}
        >
          <h4 className="text-lg font-semibold mb-4" style={{fontFamily: 'Lato,sans-serif'}}>
            Kontakt
          </h4>
          <div className="space-y-2 text-stone-300" style={{fontFamily: 'Lato,sans-serif'}}>
            <p>E-Mail: info@yin-und-klang.de</p>
            <p>Ort: Kassel und Umgebung</p>
            <p>Start: Juli 2025</p>
            <a
              href="https://www.instagram.com/yin_und_klang_kassel/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YIN UND KLANG auf Instagram öffnen"
              className="inline-flex items-center gap-2 text-stone-300 hover:text-amber-300 transition-colors"
            >
              <SafeIcon icon={FiInstagram} className="w-5 h-5" />
              <span>Instagram</span>
            </a>
            <a
              href="https://22e47eb6.sibforms.com/serve/MUIFAFBi71yYTH4I3O1CekCsdBMIrLrYO1KpjvPDMjl3HHbFO95ZQCgJm2FKKUZQDEokRejTUZUiPjEVkA46HAL3lvYEyGMEe5j2hoOXzoM2QwQ20J3e3nXd2AcQ7PrCij0LT1Liq6pcbCNN9Yc36h1-HPlqdbv2TMa09gJMPWXswNul_7jK-FBrp8TUxinJLkNlnX246tt81d5E"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:text-amber-300 transition-colors"
            >
              Neue Termine per Mail
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.4}}
          viewport={{once: true}}
        >
          <h4 className="text-lg font-semibold mb-4" style={{fontFamily: 'Lato,sans-serif'}}>
            Unsere Formate
          </h4>
          <div className="space-y-2 text-stone-300" style={{fontFamily: 'Lato,sans-serif'}}>
            <p>Yin und Klang Kurs - 4 x 70 Min.</p>
            <p>Yin und Klang 3 Std. Retreat</p>
            <div className="pt-2">
              <p className="text-sm text-stone-400 mb-1">Achtsamkeit in der Natur</p>
              <a
                href="https://natur-und-klang.de"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block font-semibold transition-colors hover:opacity-80"
                style={{color: '#CBB8A9'}}
              >
                natur-und-klang.de
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.6}}
          viewport={{once: true}}
        >
          <h4 className="text-lg font-semibold mb-4" style={{fontFamily: 'Lato,sans-serif'}}>
            Rechtliches
          </h4>
          <div className="space-y-2 text-stone-300">
            <Link to="/impressum" className="block hover:text-amber-300 transition-colors" style={{fontFamily: 'Lato,sans-serif'}}>
              Impressum
            </Link>
            <Link to="/datenschutz" className="block hover:text-amber-300 transition-colors" style={{fontFamily: 'Lato,sans-serif'}}>
              Datenschutz
            </Link>
            <Link to="/widerrufsbelehrung" className="block hover:text-amber-300 transition-colors" style={{fontFamily: 'Lato,sans-serif'}}>
              Widerrufsrecht
            </Link>
            <Link to="/agb" className="block hover:text-amber-300 transition-colors" style={{fontFamily: 'Lato,sans-serif'}}>
              AGB
            </Link>
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{opacity: 0}}
        whileInView={{opacity: 1}}
        transition={{duration: 0.6, delay: 0.8}}
        viewport={{once: true}}
        className="border-t border-stone-700 mt-8 pt-8 text-center text-stone-400"
      >
        <p style={{fontFamily: 'Lato,sans-serif'}}>
          &copy;2025-2026 YIN UND KLANG - Nadine Rau u. Mike Trepte GbR. Alle Rechte vorbehalten.
        </p>
      </motion.div>
    </div>
  </footer>
);

export default Footer;